import React, { Component } from "react";
import { connect } from 'react-redux';
import _ from "../../shared/utils/ObjectUtils";
import Validators from "../../shared/utils/Validators";
import { I18n } from "react-redux-i18n";
import actions from "../../users/actions";
import authActions from "../../auth/actions";
import UsersForm from "../../users/components/UsersForm";

class PersonalAreaPageContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formHasErrors: false,
            viewMode: true,
            editMode: false,
            alert: {
                show: false
            },
            userFormData: {
                firstName: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                lastName: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                email: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                status: {
                    value: undefined,
                    required: true
                },
                role: {
                    value: undefined
                },
                entity: {
                    value: undefined
                },
                language: {
                    value: undefined,
                    error: undefined,
                    data: [],
                    required: true
                },
                timezone: {
                    value: undefined,
                    error: undefined,
                    data: []
                }
            },
            role: {},
            entity: {}
        }
    }

    componentDidMount() {
        const { getUserData, getUserPageRefresh } = this.props;
        getUserPageRefresh();
        getUserData();
    };

    componentWillReceiveProps(nextProps) {
        //Handle Error, Edit and Create
        if (this.props.loadingEditRequest && !nextProps.loadingEditRequest) {
            if (nextProps.userWasEdited) {
                this.handleUserEditSuccess()
            } else {
                this.handleUserEditError(nextProps.error)
            }
        } else if (this.props.loadingUser && !nextProps.loadingUser) {
            this.handleUserLoadingCompleted(nextProps.userData);
        }
    };

    handleFieldChange = (id, value) => {
        this.setState({
            userFormData: {
                ...this.state.userFormData,
                [id]: {
                    ...this.state.userFormData[id],
                    value: value
                }
            }
        }, () => {
            if (_.has(this.state.userFormData[id], 'required')) {
                this.validateField(id);
            }
        })
    };

    validateField = (key) => {
        let { userFormData } = this.state;
        let error = null;
        switch (key) {
            case "email":
                error = !Validators.email(userFormData[key].value) ? I18n.t('users.errors.invalidEmail') : undefined;
                break;
            default:
                if (!_.isNilOrEmpty(userFormData[key].error) &&
                    userFormData[key].required &&
                    !_.isNilOrEmpty(userFormData[key].value)) {
                    error = undefined;
                } else if (userFormData[key].required &&
                    _.isNilOrEmpty(userFormData[key].value)) {
                    error = I18n.t('forms.errors.emptyRequiredField')
                }
                break;
        }
        if (error !== userFormData[key].error) {
            userFormData[key].error = error;
            this.setState({
                userFormData,
                formHasErrors: !_.isNilOrEmpty(error)
            });
        }
    };

    handleOnFieldBlur = (key) => {
        this.validateField(key)
    };

    handleSubmitClick = () => {
        let { userFormData, formHasErrors } = this.state
        const { editUser, loggedInUserId } = this.props

        if (!formHasErrors) {
            _.forOwn(userFormData, field => {
                if (field.required && _.isNilOrEmpty(field.value)) {
                    field.error = I18n.t('forms.errors.emptyRequiredField');
                    formHasErrors = true;
                } else {
                    field.error = undefined;
                }
            })
            if (!formHasErrors) {
                const formDataToBeSubmitted = Object.entries(userFormData).reduce((acc, keyValuePair) => {
                    return {
                        ...acc,
                        [keyValuePair[0]]: keyValuePair[1].value,
                    }
                }, {})
                const userFullName = formDataToBeSubmitted.firstName + " " + formDataToBeSubmitted.lastName;
                this.setState({
                    alert: {
                        show: true,
                        type: "warning",
                        title: I18n.t('users.alerts.edit.title'),
                        html: I18n.t('users.alerts.edit.text', { user: userFullName }),
                        confirmButtonText: I18n.t('forms.submit'),
                        cancelButtonText: I18n.t('forms.cancel'),
                        onCancel: this.hideAlert,
                        onConfirm: () => {
                            editUser(loggedInUserId, formDataToBeSubmitted, true)
                        }
                    }
                })
            }
        } else {
            this.setState({
                userFormData,
                formHasErrors
            });
        }
    }

    handleEditClick = () => {
        const { editMode } = this.state;
        const { userData } = this.props;

        if (editMode) {
            this.setState({
                ...this.state,
                editMode: false,
                viewMode: true,
                userFormData:
                    Object.entries(userData).reduce((acc, [key, value]) => {
                        return {
                            ...acc,
                            [key]: {
                                value: key === 'entity' || key === 'role' ? value.id : userData[key],
                                error: undefined,
                            }
                        }
                    }, {})
            })
        } else {
            this.setState({
                viewMode: false,
                editMode: true
            })
        }
    };

    hideAlert = () => {
        this.setState({
            alert: {
                show: false
            }
        })
    };

    handleBackClick = () => {
        const {
            history
        } = this.props;

        this.hideAlert();
        history.goBack();
    };

    handleUserEditSuccess = () => {
        const {
            userFormData: {
                firstName: {
                    value: firstName
                },
                lastName: {
                    value: lastName
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('users.alerts.edit.success.title'),
                html: I18n.t('users.alerts.edit.success.text', { user: firstName + " " + lastName }),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    };

    handleUserEditError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('users.alerts.edit.error.title'),
                html: I18n.t('users.alerts.edit.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    handleUserLoadingCompleted = userData => {
        this.setState({
            userFormData: {
                ...this.state.userFormData,
                ...Object.entries(userData).reduce(
                    (acc, [key, value]) => ({
                        ...acc,
                        [key]: {
                            ...acc[key],
                            value: key === 'entity' || key === 'role' ? value.id : value
                        }
                    }), {})
            },
            entity: userData.entity,
            role: userData.role
        })
    };

    render() {
        const {
            createMode,
            editMode,
            viewMode,
            userFormData,
            alert,
            entity,
            role
        } = this.state;

        const { loadingEditRequest } = this.props;

        return <UsersForm
            editMode={editMode}
            createMode={createMode}
            viewMode={viewMode}

            personalAreaMode={true}
            hasDelete={false}

            alert={{
                ...alert,
                loading: loadingEditRequest
            }}

            userFormData={userFormData}
            entityList={[{
                value: entity.id,
                label: entity.name
            }]}
            roleList={[{
                value: role.id,
                label: role.name
            }]}

            handleFieldChange={this.handleFieldChange}
            handleOnFieldBlur={this.handleOnFieldBlur}
            handleSubmitClick={this.handleSubmitClick}

            handleEditClick={this.handleEditClick}
            handleDeleteClick={this.handleDeleteClick}
            handleBackClick={this.handleBackClick}
        />
    }
}

const mapStateToProps = ({
    usersReducer,
    authReducer
}) => {
    return {
        loggedInUserId: authReducer.id,

        userData: authReducer.userData,
        loadingUser: authReducer.loadingPersonalInfoRequest,
        error: authReducer.loadPersonalInfoError,

        loadingEditRequest: usersReducer.loadingEditRequest,
        userWasEdited: usersReducer.userWasEdited
    };
};

const mapDispatchToProps = {
    getUserData: authActions.getUserPersonalInfo,
    getUserPageRefresh: authActions.getUserPageRefresh,
    editUser: actions.editUser
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PersonalAreaPageContainer);